import { render, staticRenderFns } from "./RegistroMesero.vue?vue&type=template&id=54a04e48"
import script from "./RegistroMesero.vue?vue&type=script&lang=js"
export * from "./RegistroMesero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports